export const MAX_BUTTONS = 3;
export const MAX_VARIABLES = 10;
export const MAX_MESSAGE_LENGTH = 1024;
